import { render, staticRenderFns } from "./cp_jl_sq.vue?vue&type=template&id=0d0cb465&scoped=true"
import script from "./cp_jl_sq.vue?vue&type=script&lang=js"
export * from "./cp_jl_sq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0cb465",
  null
  
)

export default component.exports